import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Phone, Users } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const ExtensionNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected, type }) => {
  const isGroup = type === 'extension_group';
  const IconComponent = isGroup ? Users : Phone;
  
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-purple-50 to-purple-100
        ${selected ? 'border-purple-500 shadow-lg' : 'border-purple-300 shadow'}
        min-w-[180px]
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-purple-500 !w-3 !h-3"
      />

      <div className="flex items-center gap-2 mb-2">
        <IconComponent className="h-5 w-5 text-purple-600" />
        <div className="flex-1">
          <div className="font-semibold text-purple-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-purple-700">{data.description}</div>
          )}
        </div>
        {!data.enabled && (
          <div className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded">
            Disabled
          </div>
        )}
      </div>

      {data.dialplanConfig?.extensionNumber && (
        <div className="text-xs text-purple-700 mt-1">
          Ext: {data.dialplanConfig.extensionNumber}
        </div>
      )}

      {data.priority !== undefined && (
        <div className="text-xs text-purple-700 mt-1">
          Priority: {data.priority}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="!bg-purple-500 !w-3 !h-3"
      />
    </div>
  );
};

